<template>
  <artisio-modal :visible="show" :title="title" body-class="pdf-modal-body p-0" size="xl" scrollable hide-footer
                 :content-in-form="false" @hidden="hideModal" modal-class="pdf-modal mobile-full-screen">
    <spinner :show="loading"/>
    <div class="data-wrapper" v-if="!loading">
      <div class="pdf-header d-flex justify-content-between" v-if="actions && actions.length > 0">
        <div class="p-2 header-actions-wrapper">
          <div v-for="(action, index) in actions" :key="`${index}-pdf-modal-actions-btn`">
            <b-button variant="primary" :disabled="!base64 && !pdf_url" class="mr-2 header-action-btn"
                      @click="action.handler()">
              {{ action.display_name }}
            </b-button>
          </div>
        </div>
      </div>
      <hr v-if="!base64 && !pdf_url">
      <template v-if="pdf_url || base64">
        <div v-if="isIOS" class="pdf-open-link-wrapper">
          <b-button variant="primary" @click="openPdfOnIOS">
            {{ $t('Open PDF') }}
          </b-button>
        </div>
        <template v-else>
          <iframe class="pdf-modal-pdf-iframe" @load="onPdfUrlIframeLoad" v-if="pdf_url" :src="pdf_url"/>
          <iframe class="pdf-modal-pdf-iframe" v-else-if="blobUrl" :src="blobUrl"/>
        </template>
      </template>
      <div v-else-if="content" class="pdf-content" v-html="content"></div>
      <iframe id="printContent" style="display: none;"></iframe>
    </div>
  </artisio-modal>
</template>

<script>
  import EventBus from "../../../plugins/event-bus";
  import {ON_PDF_MODAL_DATA_RETRIEVE, ON_PDF_MODAL_OPEN, ON_PDF_MODAL_CLOSE} from "@/plugins/event-bus/event-bus-names";
  import Spinner from "../common/Spinner";
  import ArtisioModal from "../artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex"

  const {mapActions} = createNamespacedHelpers('invoices');


  export default {
    name: "PdfModal",
    components: {ArtisioModal, Spinner},
    data() {
      return {
        loading: false,
        show: false,
        title: null,
        filename: null,
        content: null,
        base64: null,
        pdf_url: null,
        blobUrl: null,
        actions: []
      }
    },
    computed: {
      isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      },
    },
    methods: {
      ...mapActions(['markCollected']),
      hideModal() {
        this.title = null;
        this.base64 = null;
        this.pdf_url = null;
        this.revokeBlobUrl();
        this.show = false;
      },
      initData({base64, content, filename, pdf_url}) {
        this.base64 = base64;
        this.content = content;
        this.filename = filename;
        this.pdf_url = pdf_url;
        this.revokeBlobUrl();
        if (base64) {
          this.blobUrl = this.createBlobUrl(base64);
        }
        this.loading = false;
      },
      // Chromium refuses to load URLs over 2MB, so large PDFs can't be shown via data: URLs
      createBlobUrl(base64) {
        const bytes = atob(base64);
        const byteArray = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
          byteArray[i] = bytes.charCodeAt(i);
        }
        return URL.createObjectURL(new Blob([byteArray], {type: 'application/pdf'}));
      },
      revokeBlobUrl() {
        if (this.blobUrl) {
          URL.revokeObjectURL(this.blobUrl);
          this.blobUrl = null;
        }
      },
      onDownloadClick() {
        const downloadLink = document.createElement("a");
        const fileName = `${this.filename}.pdf`;

        downloadLink.href = this.blobUrl;
        downloadLink.download = fileName;
        downloadLink.click();
      },
      onPrintClick() {
        let iframe = document.getElementById('printContent');
        let body = iframe.contentWindow.document.getElementsByTagName('body')[0];
        body.innerHTML = this.content;
        iframe.contentWindow.print()
      },
      onPdfUrlIframeLoad() {
        this.loading = false;
      },
      openPdfOnIOS() {
        if (this.pdf_url) {
          window.open(this.pdf_url, '_blank');
          return;
        }
        if (this.blobUrl) {
          window.open(this.blobUrl, '_blank');
        }
      },
    },
    beforeMount() {
      this.show = false;
      EventBus.$on(ON_PDF_MODAL_OPEN, ({title, data, actions = []}) => {
        this.title = title;
        this.show = true;
        this.loading = true;
        this.actions = actions;

        if (data) {
          this.initData(data);
        }
      });
      EventBus.$on(ON_PDF_MODAL_DATA_RETRIEVE, (data) => this.initData(data));
      EventBus.$on(ON_PDF_MODAL_CLOSE, () => this.hideModal())
    },
    beforeDestroy() {
      EventBus.$off(ON_PDF_MODAL_OPEN);
      EventBus.$off(ON_PDF_MODAL_DATA_RETRIEVE);
      this.revokeBlobUrl();
    }
  }
</script>

<style lang="scss">
  .pdf-modal {
    .pdf-modal-body {
      .data-wrapper {
        height: calc(100vh - 10em) !important;
        display: flex;
        justify-content: center;
        flex-direction: column;

        .pdf-modal-pdf-iframe {
          width: 100%;
          height: 100%;
        }

        .pdf-open-link-wrapper {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .pdf-document {
    .items-table {
      td {
        &:first-child {
          overflow-wrap: anywhere;
        }
      }
    }
  }

  .header-actions-wrapper {
    display: flex;
  }

  .header-action-btn {
    flex: 2;
  }
</style>
